import { Injectable } from '@angular/core';

import { icons } from '@finnairoyj/fcom-ui-styles';

import { IconsService } from './icons.service';

export interface IconsData {
  name: string;
  category?: string;
}

const SVG_LIBRARY = 'svg-library';

/**
 * Helper service for adding Icons from the ui-styles icons manifest to the icons service without inserting an fcom-icon into the dom
 */
@Injectable({
  providedIn: 'root',
})
export class IconsPreloadService {
  private icons = icons;

  constructor(private readonly iconsService: IconsService) {}

  /**
   * function for adding icons by name from the ui-styles icons manifest into the icon service
   *
   * @param iconsData
   */
  preloadIcons(iconsData: IconsData | IconsData[]): void {
    if (!iconsData) {
      return;
    }
    if (Array.isArray(iconsData)) {
      iconsData.forEach((iconData) => this.addIcon(iconData.name, iconData.category || SVG_LIBRARY));
    } else {
      this.addIcon(iconsData.name, iconsData.category || SVG_LIBRARY);
    }
  }

  private addIcon(name, category = SVG_LIBRARY): void {
    if (this.icons[category]?.[name]) {
      const id = `${category}/${String(name)}`;
      this.iconsService.addIcon(id, this.icons[category][name]);
    }
  }
}
